export const mixinDocuments = {
    data() {
        return {
            singleOrMultiDocuments: [],
        }
    },
    methods: {
        documentOutput(newDocument) {
            this.singleOrMultiDocuments.push(newDocument)
        },
        clearDocumentList() {
            this.singleOrMultiDocuments = []
        }
    }
}